// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frisbuy-sr-branding[data-v-92e2786e]{width:64px;height:35px;flex-shrink:0;font-size:8px;line-height:9px;color:#000;opacity:.5;text-decoration:none;text-align:center}.frisbuy-sr-branding svg[data-v-92e2786e]{margin-top:4px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
